import TencentCloudChat from '@tencentcloud/chat';
import store from '@/store';
import { accountToTencentApi, chatUserInfoApi, getGroupStatusApi } from '@/api/chat.js'
import LibGenerateTestUserSig from './lib-generate-test-usersig-es.min.js';
import { Message, Notification } from 'element-ui';
import EventBus from './event-bus.js';
// import TIMUploadPlugin from 'tim-upload-plugin';
class tencentChat {
    client;
    SDKAPPID = 1600028250;
    SECRETKEY = "cb99d6cf0bbe6d86af21a040198968531d9c5a10c0defa66e939f67c8ba506fd"
    EXPIRETIME = 604800;
    USERID;
    constructor() {
        console.log("重新初始化TencentCloudChat");
        let options = {
            SDKAppID: this.SDKAPPID,
        };
        if (!this.client) {
            this.client = TencentCloudChat.create(options);
            this.client.setLogLevel(1);
            if (store.state.uid > 0) {
                this.loginIn();
            }
        }
    }


    loginIn() {
        let that = this;
        // console.log("登录腾讯客户端:", store.state.uid);
        this.USERID = store.state.uid.toString();
        that.client.on(TencentCloudChat.EVENT.MESSAGE_RECEIVED, that.onMessageReceived);
        let userSig = that.genTestUserSig()
        //let onSdkReady = function() {
        that.client.login({
            userID: that.USERID,
            userSig
        }).then(function (imResponse) {
            // console.log("登录腾讯客户端成功：", imResponse)
            if (imResponse.data.repeatLogin === true) {
                console.log(imResponse.data.errorInfo); // 标识账号已登录，本次登录操作为重复登录。
            } else {
                setTimeout(() => {
                    that.updateMyProfile();
                }, 100)
            }
        }).catch(function (imError) {
            console.warn('login error:', imError); // 登录失败的相关信息
        });
        // }
        // setTimeout(() => {
        // 	that.client.on(TencentCloudChat.EVENT.SDK_READY, onSdkReady);
        // }, 1000)
        let onTotalUnreadMessageCountUpdated = function (event) {
            // console.log(event, '当前单聊和群聊会话的未读总数'); // 当前单聊和群聊会话的未读总数
        };
        this.client.on(TencentCloudChat.EVENT.TOTAL_UNREAD_MESSAGE_COUNT_UPDATED, onTotalUnreadMessageCountUpdated);

    }

    loginOut() {
        let that = this;
        let onSdkReady = function () {
            let promise = that.client.logout();
            promise.then(function (imResponse) {
                console.log("退出腾讯客户端成功：", imResponse.data); // 登出成功
            }).catch(function (imError) {
                console.warn('logout error:', imError);
            });
        };
        that.client.on(TencentCloudChat.EVENT.SDK_READY, onSdkReady);
        onSdkReady();
    }

    destruct() {
        console.log("销毁TencentChat对象===============================")
        this.client.destroy();
    }

    pinConversation(conversationID, status = true) {
        console.log(conversationID, status)
        let promise = this.client.pinConversation({
            conversationID: conversationID,
            isPinned: status
        });
        promise.then(function (imResponse) {
            // 置顶会话成功
            const {
                conversationID
            } = imResponse.data; // 被置顶的会话 ID
            // console.log(conversationID,'置顶')
        }).catch(function (imError) {
            // code - 50002 会话 ID 无效
            console.warn('pinConversation error:', imError); // 置顶会话失败的相关信息
        });
    }
    clearHistoryMessage(conversationID) {
        // 清空单聊的本地及云端的消息
        // console.log("清空消息成功" + conversationID)

        let promise = this.client.clearHistoryMessage(conversationID);
        promise.then(function (imResponse) {
            // console.log("清空消息成功" + conversationID)
            EventBus.$emit('clearHistory_' + conversationID);
            // 清空消息成功
        }).catch(function (imError) {
            console.warn('clearHistoryMessage error:', imError); // 清空消息失败的相关信息
        });
    }
    deleteConversation(conversationID) {
        // 删除单一会话, 并清空会话历史消息
        let promise = this.client.deleteConversation(conversationID);
        promise.then(function (imResponse) {
            // 删除会话成功
            const {
                conversationID
            } = imResponse.data; // 被删除的会话 ID
        }).catch(function (imError) {
            console.warn('deleteConversation error:', imError); // 删除会话失败的相关信息
        });
    }
    addToBlacklist(userIDList) {
        console.log(userIDList);
        this.client.addToBlacklist({
            userIDList: userIDList
        }).catch(function (imError) {
            console.warn('deleteConversation error:', imError); // 删除会话失败的相关信息
        });
    }
    removeFromBlacklist(userIDList) {
        console.log(userIDList);
        this.client.removeFromBlacklist({
            userIDList: userIDList
        }).then(function (imResponse) {
            console.log(imResponse); // 更新资料成功
        }).catch(function (imError) {
            console.warn('deleteConversation error:', imError); // 删除会话失败的相关信息
        })
    }
    getBlacklist() {
        this.client.getBlacklist().then(function (imResponse) {
            console.log(imResponse.data); // 我的黑名单列表，结构为包含用户 userID 的数组 - [userID]
        }).catch(function (imError) {
            console.warn('getBlacklist error:', imError); // 获取黑名单列表失败的相关信息
        });
    }
    markConversation(conversationIDs, status = true) {
        // 会话标星
        let promise = this.client.markConversation({
            conversationIDList: conversationIDs,
            markType: TencentCloudChat.TYPES.CONV_MARK_TYPE_STAR,
            enableMark: true
        });
        promise.then(function (imResponse) {
            // 会话标星成功
            const {
                successConversationIDList,
                failureConversationIDList
            } = imResponse.data;
            // successConversationIDList - 标星成功的会话 ID 列表
            // 获取会话列表
            // const conversationList = TencentCloudChat.getConversationList(successConversationIDList);
            // // failureConversationIDList - 标星失败的会话 ID 列表
            // failureConversationIDList.forEach((item) => {
            // 	const {
            // 		conversationID,
            // 		code,
            // 		message
            // 	} = item;
            // });
        }).catch(function (imError) {
            console.warn('markConversation error:', imError);
        });

    }

    updateMyProfile() {
        let userinfo = store.state.userInfo
        let promise = this.client.updateMyProfile({
            nick: userinfo.nickname,
            avatar: userinfo.avatar,
            allowType: TencentCloudChat.TYPES.ALLOW_TYPE_ALLOW_ANY
        });
        promise.then(function (imResponse) {
            //console.log(imResponse.data); // 更新资料成功
        }).catch(function (imError) {
            console.warn('updateMyProfile error:', imError); // 更新资料失败的相关信息
        });
    }

    onMessageReceived = function (event) {
        // event.data - 存储 Message 对象的数组 - [Message]
        const messageList = event.data;
        let that = this;
        messageList.forEach((message) => {
            if (message.type === TencentCloudChat.TYPES.MSG_TEXT) {
                // 文本消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.TextPayload
            } else if (message.type === TencentCloudChat.TYPES.MSG_IMAGE) {
                // 图片消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.ImagePayload
            } else if (message.type === TencentCloudChat.TYPES.MSG_SOUND) {
                // 音频消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.AudioPayload
            } else if (message.type === TencentCloudChat.TYPES.MSG_VIDEO) {
                // 视频消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.VideoPayload
            } else if (message.type === TencentCloudChat.TYPES.MSG_FILE) {
                // 文件消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.FilePayload
            } else if (message.type === TencentCloudChat.TYPES.MSG_CUSTOM) {
                // 自定义消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.CustomPayload
            } else if (message.type === TencentCloudChat.TYPES.MSG_MERGER) {
                // 合并消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.MergerPayload
            } else if (message.type === TencentCloudChat.TYPES.MSG_LOCATION) {
                // 地理位置消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.LocationPayload
            } else if (message.type === TencentCloudChat.TYPES.MSG_GRP_TIP) {
                // 群提示消息 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.GroupTipPayload
            } else if (message.type === TencentCloudChat.TYPES.MSG_GRP_SYS_NOTICE) {
                // 群系统通知 - https://web.sdk.qcloud.com/im/doc/v3/zh-cn/Message.html#.GroupSystemNoticePayload
                const {
                    operationType,
                    userDefinedField
                } = message.payload;
                // operationType - 操作类型
                // userDefinedField - 用户自定义字段（对应 operationType 为 255）
                // 使用 RestAPI 在群组中发送系统通知时，接入侧可从 userDefinedField 拿到自定义通知的内容。
            }
        });
        messageList.forEach(item => {
            let alertSound = new Audio('https://dsjszkj.oss-cn-beijing.aliyuncs.com/uploads/voice/aigei_com.mp3')
            if (item.conversationType == 'C2C') {
                console.log('监听来自_tencentChatJs------------------------- dialogue_listen_C2C' + item.from);
                EventBus.$emit('dialogue_listen_C2C' + item.from, JSON.stringify(item)); //更新到对话中
                if (store.state.show_prompt_sound && store.state.userInfo.shop_status == 1) {
                    Notification({
                        title: '提示',
                        dangerouslyUseHTMLString: true,
                        message: `<div style="color:#46c396;">您有一条来自<strong>"${item.nick}"</strong>的消息，请及时处理。</div>`
                    });
                    alertSound.play();
                }
            } else {
                console.log('监听来自_tencentChatJs------------------------- dialogue_listen_' + item.conversationID);
                EventBus.$emit('dialogue_listen_' + item.conversationID, JSON.stringify(item)); //更新到对话中
            }
            EventBus.$emit('conversation_listen', JSON.stringify(item)); //更新会话列表
        });
    };
    async createAccount(touid) {
        console.log(touid);
        let res = await accountToTencentApi({
            touid: touid
        })
        return this.client;
    }

    createForwardMessage(chatType, acceptUid, message, msgType) {
        acceptUid = acceptUid.toString();
        console.log(message);
        let forwardMessage

        forwardMessage = this.client.createForwardMessage({
            to: acceptUid,
            conversationType: chatType == 'C2C' ? TencentCloudChat.TYPES.CONV_C2C : TencentCloudChat
                .TYPES.CONV_GROUP,
            // 消息优先级，用于群聊
            // priority: TencentCloudChat.TYPES.MSG_PRIORITY_NORMAL,
            payload: message,
        });
        console.log(forwardMessage);

        // 2. 发送消息
        return this.client.sendMessage(forwardMessage);
    }



    async createMessage(chatType, type, acceptUid, payload, callback = function () { }) {
        // console.log(chatType, type, acceptUid, payload);
        let message;
        acceptUid = acceptUid.toString();
        let is_forbid = false
        let banned = false
        if (chatType !== 'C2C') {
            let res = await chatUserInfoApi({
                group_id: acceptUid
            })
            if (res.data.role == 1 || res.data.role == 2) {
                is_forbid = false
            } else {
                is_forbid = res.data.forbid_type == 1 || res.data.forbid_type == 2 ? true : false
            }
            if (is_forbid) {
                Message.error('禁言中...');
            }
            let result = await getGroupStatusApi({
                id: acceptUid
            })
            if (result.data.status == 5 || result.data.status == 6) {
                banned = true
                Message.error(result.data.status == 5 ? `此群封禁${result.data.banned_duration}天` : `此群永久封禁`);
            }
        }

        // console.log(banned, is_forbid);
        if (!banned && !is_forbid) {
            switch (type) {
                case 'text':
                    payload.data = type;
                    message = this.client.createCustomMessage({
                        to: acceptUid,
                        conversationType: chatType == 'C2C' ? TencentCloudChat.TYPES.CONV_C2C :
                            TencentCloudChat
                                .TYPES.CONV_GROUP,
                        payload: payload,
                    });
                    break;
                default:
                    payload.data = type;
                    message = this.client.createCustomMessage({
                        to: acceptUid,
                        conversationType: chatType == 'C2C' ? TencentCloudChat.TYPES.CONV_C2C :
                            TencentCloudChat
                                .TYPES.CONV_GROUP,
                        payload: payload,
                    });
                    break;
            }
            return this.client.sendMessage(message);
        }





    }
    send2C2Message(type, acceptUid, params) {
        let message;
        acceptUid = acceptUid.toString();
        switch (type) {
            case 'text':
                message = this.client.createTextMessage({
                    to: acceptUid,
                    conversationType: TencentCloudChat.TYPES.CONV_C2C,
                    payload: {
                        text: params.content
                    }
                });
                break;
            case 'image':
                message = this.client.createImageMessage({
                    to: acceptUid,
                    conversationType: TencentCloudChat.TYPES.CONV_C2C,
                    payload: {
                        file: params.content
                    },
                    onProgress: function (event) {
                        console.log('file uploading:', event)
                    }
                });
                break;
        }
        return this.client.sendMessage(message);
    }

    genTestUserSig() {
        const generator = new LibGenerateTestUserSig(this.SDKAPPID, this.SECRETKEY, this.EXPIRETIME);
        const userSig = generator.genTestUserSig(this.USERID);
        return userSig;
    }
}

export default new tencentChat();